// src/app/services/qrcode.service.ts
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

export type DecodedToken = {
  route: 'note' | 'qrcode';
  name?: string;
  id: number;
  code: string;
  table: number;
};

@Injectable({ providedIn: 'root' })
export class QRCodeService {
  private apiUrl = 'https://collect-sandbox.fulleapps.io/v1/url-token/generate';

  constructor(private http: HttpClient) { }

  generateQRCodeUrl(user_id: number, code: string, table_id: number) {
    return this.http.post<{ url: string }>(this.apiUrl, {
      route: 'qrcode',
      user_id,
      code,
      table_id
    });
  }

  generateNoteUrl(id: number, code: string, table_number: number, denomination: string) {
    return this.http.post<{ url: string }>(this.apiUrl, {
      route: 'note',
      id,
      code,
      table_number,
      denomination
    });
  }

  /* NOUVEL ENCODAGE
    id_point_of_sale: 90680 -> via point_of_sale -> code: "mja2njc5xzy5ngy"
    id_user : 87141
    location_devices : iF8aXSxd -> n_location = table
  */

  encodeToken(payload: any): string {
    let jsonObj: any  = {
      route: 'note',
      denomination: payload.name,
      code: payload.code,
      id: payload.id,
      table_number: payload.table,
    };

    const json = JSON.stringify(jsonObj);
    // console.log("jsonObj = " + json)
    const base64 = btoa(json);

    // ton decodeToken attend "part1.part2" → on peut mettre juste un séparateur vide
    return `${base64}.`;
  }

  decodeToken(token: string): DecodedToken {
    const parts = token.split('.');

    if (!parts || parts.length !== 2) {
      throw new Error('Token mal formé ou manquant');
    }

    const [base64] = parts;

    const json = atob(base64);

    const decodedPayload = JSON.parse(json);

    if (decodedPayload.route === 'note') {
      return {
        route: 'note',
        name: decodedPayload.denomination,
        code: decodedPayload.code,
        id: decodedPayload.id,
        table: decodedPayload.table_number,
      };
    } else if (decodedPayload.route === 'qrcode') {
      return {
        route: 'qrcode',
        code: decodedPayload.code,
        id: decodedPayload.user_id,
        table: decodedPayload.table_id,
      };
    } else {
      throw new Error('Route inconnue dans le token');
    }
  }
}
